import React from 'react';

export default ({ header, content, closeNotification }) => (
  <div
    data-notification
    className="bx--inline-notification bx--inline-notification--warning"
    role="alert"
  >
    <div className="bx--inline-notification__details">
      <svg
        className="bx--inline-notification__icon"
        fill="#efc100"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <path d="M.75 16a.75.75 0 0 1-.67-1.085L7.33.415a.75.75 0 0 1 1.34 0l7.25 14.5A.75.75 0 0 1 15.25 16H.75zm6.5-10v5h1.5V6h-1.5zM8 13.5A.75.75 0 1 0 8 12a.75.75 0 0 0 0 1.5z" />
      </svg>
      <div>
        <p className="mg-left-10">
          <strong>
            {header}
            {':'}
          </strong>
          <br />
          {content}
        </p>
      </div>
    </div>
    <button
      onClick={closeNotification}
      data-notification-btn
      className="bx--inline-notification__close-button"
      type="button"
    >
      <svg
        className="bx--inline-notification__close-icon"
        aria-label="close"
        width="10"
        height="10"
        viewBox="0 0 10 10"
      >
        <path d="M6.32 5L10 8.68 8.68 10 5 6.32 1.32 10 0 8.68 3.68 5 0 1.32 1.32 0 5 3.68 8.68 0 10 1.32 6.32 5z" />
      </svg>
    </button>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/WarningNotification.js